module.exports = __webpack_public_path__ + "img/ag.7d86d7ba.jpg";